export default __webpack_public_path__ + "static/media/check-circle.ff2ce883.svg";